import * as yup from 'yup';

// Copied from GetStartedDE.schema.ts — keep in sync if the desktop rule changes.
export const emailSchema = yup.object().shape({
  email: yup
    .string()
    .email('ungültige Eingabe')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: 'ungültige Eingabe',
      excludeEmptyString: true,
    })
    .required('benötigt'),
  marketingOptIn: yup.boolean().optional(),
});
